export const environment = {
  baseUrl: "https://api.iclouddental.zimotechnologies.in",
  socketUrl: "wss:api.iclouddental.zimotechnologies.in",
  frontEndUrl: "https://staging.iclouddental.zimotechnologies.in",
  SotaCloudBaseUrl: "https://edental.sotadevices.com"
}
